import { Badge } from '../../../components/Badge';

interface BooleanTagProps {
  value: boolean;
}

export const BooleanTag = (props: BooleanTagProps) => {
  return <Badge variant={'secondary'}>{props.value.toString()}</Badge>;
};
